export default "__VITE_ASSET__CmYD7BKH__"